var render = function render(_c,_vm){return _c('div',{class:[_vm.$style.root, _vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_vm._t("default"),_c('span',{class:_vm.$style.value},[_vm._v(_vm._s(_vm.props.value.toLocaleString()))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }